<template>
  <div name="hrms18e-popup-parent" id="hrms18e-popup-parent" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header header-popup clearfix">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title"></h4>
        </div>

        <div class="modal-body detail detail-responsive">
          <div class="box-body">
            <form role="form">
              <div class="row">
                <div class="col-xs-6 col-ms-6 col-sm-6">
                  <div class="form-group clearfix">
                    <label>{{labels['HRMS18E']['430']}}</label>
                    <hrms-datepicker  v-model="postParams.dtestrt"
                                      v-validate="'requiredWhenExist:dteend|date_format:DD/MM/YYYY|date_between:' + moment(limit.from, 'YYYY-MM-DD').format('DD/MM/YYYY') + ',' + moment(limit.to, 'YYYY-MM-DD').format('DD/MM/YYYY')"
                                      data-vv-value-path="inputDate"
                                      data-vv-name="dtestrt"
                                      name="dtestrt" />
                    <span v-show="errors.has('dtestrt')" class="text-error">{{ errors.first('dtestrt') }}</span>
                  </div>
                </div>
                <div class="col-xs-6 col-ms-6 col-sm-6">
                  <div class="form-group clearfix">
                    <label>{{labels['HRMS18E']['440']}}</label>
                    <hrms-datepicker  v-model="postParams.dteend"
                                      v-validate="'requiredWhenExist:dtestrt|date_format:DD/MM/YYYY|date_between:' + moment(limit.from, 'YYYY-MM-DD').format('DD/MM/YYYY') + ',' + moment(limit.to, 'YYYY-MM-DD').format('DD/MM/YYYY')"
                                      data-vv-value-path="inputDate"
                                      data-vv-name="dteend"
                                      name="dteend" />
                    <span v-show="errors.has('dteend')" class="text-error">{{ errors.first('dteend') }}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-6 col-ms-6 col-sm-6">
                  <div class="form-group clearfix">
                    <label>{{labels['HRMS18E']['190']}}</label>
                    <hrms-lov   v-model="postParams.codshift"
                                :nowLang="nowLang"
                                lovType="codshift"
                                v-validate="''"
                                data-vv-value-path="inputValue"
                                data-vv-name="codshift"
                                name="codshift" />
                    <span v-show="errors.has('codshift')" class="text-error">{{ errors.first('codshift') }}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-ms-12 col-sm-12">
                  <div class="form-group clearfix parent-box">

                    <input type="checkbox" id="parent-period" v-model="postParams.period" class="hidden" />
                    <label for="parent-period" class="header-collapse-box border-top-color-skin">
                      <i :class="'fa ' + [ (postParams.period == true) ? 'fa-check-square' : 'fa-square' ]"></i>
                      ตั้งค่าวันหยุดประจำรอบ
                    </label>
                    
                    <div class="option-box" v-show="postParams.period">
                      <input type="checkbox" value="MON" id="parent-mon"  v-model="postParams.day" class="hidden" />
                      <label for="parent-mon"  :class="'day color' + [ checkDaySelected('MON') ? '-holiday' : '-work']">Monday</label>
                      <input type="checkbox" value="TUE" id="parent-tue"  v-model="postParams.day" class="hidden" />
                      <label for="parent-tue"  :class="'day color' + [ checkDaySelected('TUE') ? '-holiday' : '-work']">Tuesday</label>
                      <input type="checkbox" value="WED" id="parent-wed"  v-model="postParams.day" class="hidden" />
                      <label for="parent-wed"  :class="'day color' + [ checkDaySelected('WED') ? '-holiday' : '-work']">Wednesday</label>
                      <input type="checkbox" value="THU" id="parent-thu"  v-model="postParams.day" class="hidden" />
                      <label for="parent-thu"  :class="'day color' + [ checkDaySelected('THU') ? '-holiday' : '-work']">Thursday</label>
                      <input type="checkbox" value="FRI" id="parent-fri"  v-model="postParams.day" class="hidden" />
                      <label for="parent-fri"  :class="'day color' + [ checkDaySelected('FRI') ? '-holiday' : '-work']">Friday</label>
                      <input type="checkbox" value="SAT" id="parent-sat"  v-model="postParams.day" class="hidden" />
                      <label for="parent-sat"  :class="'day color' + [ checkDaySelected('SAT') ? '-holiday' : '-work']">Saturday</label>
                      <input type="checkbox" value="SUN" id="parent-sun"  v-model="postParams.day" class="hidden" />
                      <label for="parent-sun"  :class="'day color' + [ checkDaySelected('SUN') ? '-holiday' : '-work']">Sunday</label>

                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="modal-footer align-left">
          <input type="hidden" ref="btnClosePopupParent" data-dismiss="modal">
          <button type="button" class="btn bg-color-skin" value="Ok" @click="validatePostParentTypeworkCodshiftOnPeriod()"><i class="fa fa-check-circle"></i>{{ configLabels.button[nowLang].ok }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import configLabels from 'src/../config/label'

export default {
  name: 'hrms18e-popup-parent',
  data () {
    return {
      postParams: this.parentPostParams,
      limit: {
        type: 'fromto',
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD')
      },
      configLabels: configLabels,
      moment: moment
    }
  },
  created () {
    this.setPostParamsAndLimit({ month: this.searchIndex.month, year: this.searchIndex.year })
  },
  watch: {
    'searchIndex.year' () {
      this.setPostParamsAndLimit({ month: this.searchIndex.month, year: this.searchIndex.year })
    },
    'searchIndex.month' () {
      this.setPostParamsAndLimit({ month: this.searchIndex.month, year: this.searchIndex.year })
    },
    parentPostParams () {
      this.postParams = this.parentPostParams
      if (moment(_.padStart(parseInt(this.searchIndex.month), 2, '0') + '/' + this.searchIndex.year, 'MM/YYYY').format('YYYY-MM-DD') !== moment(moment().format('MM/YYYY'), 'MM/YYYY').format('YYYY-MM-DD')) {
        this.postParams.dtestrt = '01/' + _.padStart(parseInt(this.searchIndex.month), 2, '0') + '/' + this.searchIndex.year
        this.postParams.dteend = '01/' + _.padStart(parseInt(this.searchIndex.month), 2, '0') + '/' + this.searchIndex.year
      }
    }
  },
  methods: {
    checkDaySelected (day) {
      return this.postParams.day.indexOf(day) > -1
    },
    setPostParamsAndLimit ({ month, year }) {
      if (month === undefined) {
        month = moment().month() + 1
      }
      if (year === undefined) {
        year = moment().year()
      }
      let sumDayInThisMonth = moment((year + '-' + _.padStart(parseInt(month), 2, '0') + '-01'), 'YYYY-MM-DD').daysInMonth()
      this.postParams.dtestrt = '01/' + _.padStart(parseInt(month), 2, '0') + '/' + year
      this.postParams.dteend = _.padStart(sumDayInThisMonth, 2, '0') + '/' + _.padStart(parseInt(month), 2, '0') + '/' + year
      this.limit.type = 'fromto'
      this.limit.from = year + '-' + _.padStart(parseInt(month), 2, '0') + '-' + '01'
      this.limit.to = year + '-' + _.padStart(parseInt(month), 2, '0') + '-' + _.padStart(sumDayInThisMonth, 2, '0')
      if (moment(_.padStart(parseInt(month), 2, '0') + '/' + year, 'MM/YYYY').format('YYYY-MM-DD') === moment(moment().format('MM/YYYY'), 'MM/YYYY').format('YYYY-MM-DD')) {
        this.limit.from = moment().format('YYYY-MM-DD')
      }
    },
    validatePostParentTypeworkCodshiftOnPeriod () {
      this.$validator.validateAll().then(result => {
        if (result) {
          let firstDateOfMonth = '01/' + _.padStart(parseInt(this.searchIndex.month), 2, '0') + '/' + this.searchIndex.year
          if (moment(this.postParams.dtestrt, 'DD/MM/YYYY').toDate() < moment(firstDateOfMonth, 'DD/MM/YYYY').toDate()) {
            this.postParams.dtestrt = firstDateOfMonth
          }
          let sumDayInMonth = moment((this.searchIndex.year + '-' + _.padStart(parseInt(this.searchIndex.month), 2, '0') + '-01'), 'YYYY-MM-DD').daysInMonth()
          let lastDateOfMonth = _.padStart(sumDayInMonth, 2, '0') + '/' + _.padStart(parseInt(this.searchIndex.month), 2, '0') + '/' + this.searchIndex.year
          if (moment(this.postParams.dteend, 'DD/MM/YYYY').toDate() > moment(lastDateOfMonth, 'DD/MM/YYYY').toDate()) {
            this.postParams.dteend = lastDateOfMonth
          }
          this.$refs.btnClosePopupParent.click()
          this.postParentTypeworkCodshiftOnPeriod(this.postParams)
        }
      })
    }
  },
  props: [
    'labels',
    'nowLang',
    'searchIndex',
    'parentPostParams',
    'parentCurrentTypework',
    'parentTargetTypework',
    'parentCurrentCodshift',
    'parentTargetCodshift',
    'setParentCurrentTypework',
    'setParentTargetTypework',
    'setParentCurrentCodshift',
    'setParentTargetCodshift',
    'setParentTypeworkToTargetTypework',
    'postParentTypeworkCodshiftOnPeriod',
    'childCurrentTypework',
    'childTargetTypework',
    'childCurrentCodshift',
    'childTargetCodshift',
    'setChildCurrentTypework',
    'setChildTargetTypework',
    'setChildCurrentCodshift',
    'setChildTargetCodshift'
  ]
}
</script>

<style lang="scss">

.parent-box {

  .header-collapse-box {
    width: 100%;
    border-top: 2px solid;
    border-left: 1px solid #E0E0E0;
    border-right: 1px solid #E0E0E0;
    border-bottom: 1px solid #E0E0E0;
    padding: 10px;
  }

  .option-box {
    width: 100%;
    border-left: 1px solid #E0E0E0;
    border-right: 1px solid #E0E0E0;
    border-bottom: 1px solid #E0E0E0;
    padding: 10px;

    .day {
      cursor: pointer;
      padding: 0 20px;


      &.color-work {
        color: #9E9E9E;
      }

      &.color-holiday {
        color: #D32F2F;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// popupParent.vue?54499d7c